export default __webpack_public_path__ + "static/media/EXEMPLO 9.c2bc672b.jpg";